import type { MeetingManager } from "amazon-chime-sdk-component-library-react";

/**
 * Stops all Chime SDK streams using the meeting manager.
 * Errors are logged rather than swallowed so cleanup failures are visible.
 */
export async function stopChimeStreams(
  meetingManager: MeetingManager | null
): Promise<void> {
  if (!meetingManager) return;

  try {
    try {
      await meetingManager.audioVideo?.stopVideoInput();
    } catch (e) {
      console.warn("[stopChimeStreams] Failed to stop video input:", e);
    }
    try {
      await meetingManager.audioVideo?.stopAudioInput();
    } catch (e) {
      console.warn("[stopChimeStreams] Failed to stop audio input:", e);
    }
    try {
      await meetingManager.audioVideo?.stopContentShare();
    } catch (e) {
      console.warn("[stopChimeStreams] Failed to stop content share:", e);
    }
    try {
      const tiles = meetingManager.audioVideo?.getAllVideoTiles() ?? [];
      for (const tile of tiles) {
        const tileId = tile.id();
        meetingManager.audioVideo?.removeVideoTile(tileId);
      }
    } catch (e) {
      console.warn("[stopChimeStreams] Failed to remove video tiles:", e);
    }
  } catch (e) {
    console.warn("[stopChimeStreams] Unexpected error during cleanup:", e);
  }
}
